import { render, staticRenderFns } from "./DespesaDetalhar.vue?vue&type=template&id=708f7e29"
import script from "./DespesaDetalhar.vue?vue&type=script&lang=js"
export * from "./DespesaDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports